package com.sddamico.draftmachine.ds

import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

/**
 * Draft Machine — spacing & sizing tokens. Full Kotlin translation of `tokens/spacing.css`.
 * 4px base grid. Names map to the physical rhythm of the UI.
 */
object DmSpacing {
  val space0 = 0.px
  val space1 = 0.25.cssRem // 4
  val space2 = 0.5.cssRem // 8
  val space3 = 0.75.cssRem // 12
  val space4 = 1.cssRem // 16
  val space5 = 1.25.cssRem // 20
  val space6 = 1.5.cssRem // 24
  val space8 = 2.cssRem // 32
  val space10 = 2.5.cssRem // 40
  val space12 = 3.cssRem // 48
  val space16 = 4.cssRem // 64
  val space20 = 5.cssRem // 80
  val space24 = 6.cssRem // 96

  // Container widths
  val widthProse = 42.cssRem // long-form copy
  val widthContent = 64.cssRem // primary app content
  val widthWide = 80.cssRem // dashboards / boards

  // Control heights (min 44px touch target on interactive)
  val controlSm = 2.cssRem // 32 — compact
  val controlMd = 2.75.cssRem // 44 — default
  val controlLg = 3.25.cssRem // 52 — hero CTA

  // Gutters
  val gutter = space6
  val gutterTight = space4
}
